import React from 'react';

import { Skeleton } from '@material-ui/lab';

import BaseSkeleton from '../BaseSkeleton';
import Card from '../../../Card';

import { ProductCardSkeletonProps } from './ProductCardSkeleton.types';

const ProductCardSkeleton: React.FC<ProductCardSkeletonProps> = ({ className, icon }) => {
  return (
    <Card className={`relative flex flex-justify p4 ${className}`}>
      <div className="flex flex-column">
        <BaseSkeleton width={120} height={25} className="mb2" />
        <BaseSkeleton width={120} height={25} className="mb4" />
        <BaseSkeleton width={75} height={25} className="mb2" />
        <BaseSkeleton width={50} height={25} className="mb2" />
        <div className="flex flex-row mt4">
          <Skeleton variant="rect" width={120} height={35} className="mr4 br1" />
          <Skeleton variant="rect" width={120} height={35} className='br1'/>
        </div>
      </div>
      <div className="flex flex-column mr4">
        <BaseSkeleton width={75} height={25} className="mt15 mb2" />
        <BaseSkeleton width={50} height={25} className="mb2" />
      </div>
      <div className="flex flex-column">
        {icon === 'button' ? (
          <Skeleton variant="rect" width={200} height={30} className="ml2" />
        ) : icon === 'icon' ? (
          <Skeleton variant="circle" height={36} width={36} />
        ) : null}
        <BaseSkeleton width={100} height={25} className="mt8 mb2" />
        <BaseSkeleton width={100} height={25} className="mb2" />
      </div>
    </Card>
  );
};

export default ProductCardSkeleton;
export { ProductCardSkeletonProps };
